import { useEffect, useReducer, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import SignupPage from './signup'
import AuthOtpPage from './otp'
import SigninPage from './signin'
import { getMainTheme, Text, useMainContext, useWindowSize } from '../../modules/staking'
import ForgetPassword from './forget-password'
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect'
import { useRequestForgetPasswordOtp, useRequestOtp, useVerify2fa, useVerifyForgetPasswordOtp, useVerifyOtp } from '../../core/services/react-query/useAuthQuery'
import { useQueryContext } from '../../core/contexts/query'
import { p2e } from '../../core/utils/common'
import { TABLET_SIZE, validEmailRegex } from '../../core/constants/common'
import { HOME } from '../../core/constants/urls'
import { ThemeProvider } from 'styled-components'
import { Title } from '../../styles/RegisterStyles'
import { SubmitBtn } from '../../styles/newStyles/Register.styled'
import { LoaderContainer } from '../../styles/CommonStyles'
import { PulseLoader } from 'react-spinners'
import Banners from './components/Banners'
import ModalLayout from '../../components/layouts/ModalLayout'
import Toast from '../../components/modals/Toast'



const initialState = {
	mobileOrEmail: '',
	affiliateCode: '',
	rulesAccepted: false,
	password: '',
}


export default function AuthPage() {
	const {
		main: { theme, lang },
		profile: { token },
	} = useMainContext()
	const { width } = useWindowSize()
	const { pathname } = useLocation()

	const [maintenanceModal, setMaintenanceModal] = useState(false)

	useEffect(() => {
		switch (pathname) {
			case '/auth/signup':
				setActiveLinkIndex(0)
				setActivePath('signup')
				break
			case '/auth/signup/otp':
				setActiveLinkIndex(1)
				setActivePath('signup-otp')
				break
			case '/auth/signin':
				setActiveLinkIndex(2)
				setActivePath('signin')
				break
			case '/auth/signin/otp':
				setActiveLinkIndex(3)
				setActivePath('signin-otp')
				break
			case '/auth/forget-password':
				setActiveLinkIndex(4)
				setActivePath('forget-password')
				break
			default:
				setActiveLinkIndex(0)
		}
	}, [pathname])

	const initialActiveLinkIndex = () => {
		switch (pathname) {
			case '/auth/signup':
				return 0
			case '/auth/signup/otp':
				return 1
			case '/auth/signin':
				return 2
			case '/auth/signin/otp':
				return 3
			case '/auth/forget-password':
				return 4
			default:
				return 0
		}
	}

	const [activeLinkIndex, setActiveLinkIndex] = useState(initialActiveLinkIndex)
	const [activePath, setActivePath] = useState('')

	const Subpages = [
		SignupPage,
		AuthOtpPage,
		SigninPage,
		AuthOtpPage,
		ForgetPassword
	]
	let ActiveSubpage = Subpages[activeLinkIndex]


	const navigate = useNavigate()

	const [searchParams, setSearchParams] = useSearchParams()
	const usernameParam = searchParams.get('username')
	const redirect = searchParams.get('redirect')


	const reducer = (state, action) => {
		switch (action.type) {
			case 'main':
				return {
					...state,
					mobileOrEmail: action.payload,
				}
			case 'option':
				return {
					...state,
					affiliateCode: action.payload,
				}
			case 'condition':
				return {
					...state,
					rulesAccepted: !state.rulesAccepted,
				}
			default:
				return state
		}
	}

	const otpInputRef = useRef()

	const [showAffiliate, setShowAffiliate] = useState()
	const [inputValues, setInputValues] = useReducer(reducer, initialState)
	const [signMethod, setSignMethod] = useState(null)
	const [validationStatus, setValidationStatus] = useState('normal')
	const [verifyCode, setVerifyCode] = useState('')
	const [password, setPassword] = useState('')
	const [extra, setExtra] = useState({
		deviceName: '',
		deviceVersion: '',
		osDevice: '',
		appVersion: '',
	})
	const [authCode, setAuthCode] = useState('')
	const [timer, setTimer] = useState(120)
	const [captchaToken] = useState(null)

	useEffect(() => {
		if (token) {
			navigate('/')
		}
		setExtra((_) => ({
			deviceName: browserName,
			deviceVersion: browserVersion,
			osDevice: `${osName} ${osVersion}`,
			appVersion: 1,
		}))
	}, [navigate, token])

	const makeInterval = () => {
		let interval
		interval = setInterval(() => {
			setTimer((time) => {
				if (time === 1) {
					clearInterval(interval)
				}
				return time - 1
			})
		}, 1000)
	}

	const onOtpResend = () => {
		if (timer > 0) return
		otpRefetch()
		setTimer(120)
		makeInterval()
	}

	const toggleAffiliate = () => setShowAffiliate((prevState) => !prevState)

	const {
		data: verifyData,
		isLoading: verifyLoading,
		mutate: verifyRefetch,
	} = useVerifyOtp(redirect)

	const { mutate: _2faRefetch, isLoading: verify2faLoading } = useVerify2fa(redirect)


	const { data: forgetPassOtpData, isLoading: loadingForgetPassOtpData, refetch: forgetpassOtpRefetch } = useRequestForgetPasswordOtp({
		[signMethod]: inputValues.mobileOrEmail
	})

	const { mutate: verifyForgetPasswordOtp, isLoading: verifyForgetPassOtpLoading } = useVerifyForgetPasswordOtp(() => {
		setInputValues(initialState)
		navigate('/auth/signin')
		navigate(0)
	})

	const onRequestOtpError = () => {
		setInputValues(initialState)
	}
	const {
		data: otpData,
		isLoading: otpLoading,
		refetch: otpRefetch,
	} = useRequestOtp(
		{
			[signMethod]: inputValues.mobileOrEmail,
			captcha: captchaToken,
		},
		onRequestOtpError
	)


	useEffect(() => {
		if (otpData?.success) {
			navigate(`/auth/${activeLinkIndex === 0 ? 'signup' : 'signin'}/otp`)
			makeInterval()
		}
	}, [otpData, otpLoading])

	const { setToast } = useQueryContext()

	const LOADING = otpLoading || verifyLoading || verify2faLoading || loadingForgetPassOtpData || verifyForgetPassOtpLoading
	// const LOADING = verifyLoading || verify2faLoading

	const onInputValueChange = (e, type) => {
		const payload = p2e(e?.target?.value)
		switch (type) {
			case 'main':
				validateInput(payload)
				setInputValues({ type, payload })
				break
			case 'option':
				setInputValues({ type, payload })
				break
			default:
				break
		}
	}

	useEffect(() => {
		if (usernameParam) {
			const payload = p2e(usernameParam)
			validateInput(payload)
			setInputValues({ type: 'main', payload })
		}
	}, [usernameParam])

	const validateInput = (_val) => {
		const val = p2e(_val)
		if (val && val.length > 0) {
			if (isNaN(val)) {
				// gmail
				const valid = validEmailRegex.test(val)
				setSignMethod('email')
				valid ? setValidationStatus('valid') : setValidationStatus('error')
			} else {
				// mobile
				setSignMethod('mobile')
				// eslint-disable-next-line
				if (!['۰', '0'].includes(val[0]) || val.length !== 11) {
					setValidationStatus('error')
				} else {
					setValidationStatus('valid')
				}
			}
		}
		if (val.length === 0) {
			setSignMethod(null)
			setValidationStatus('normal')
		}
	}

	const onSubmitClicked = () => {
		if (LOADING) return
		if (activeLinkIndex === 0 && !inputValues.rulesAccepted) {
			setToast({
				isError: true,
				show: true,
				message: 'register-rules-accept',
			})
		}
		if (
			validationStatus === 'valid' &&
			(inputValues.rulesAccepted || activeLinkIndex === 2)
		) {

			if (activeLinkIndex === 0) {
				if (inputValues.rulesAccepted) {
					setValidationStatus('normal')
					otpRefetch()
				}
			} else {
				setValidationStatus('normal')
				otpRefetch()
			}
		}
		if ((activeLinkIndex === 1 || activeLinkIndex === 3) && validationStatus === 'valid') {
			if (verifyData?.data?.data?.authenticator) {
				_2faRefetch()
			} else {
				let payload = {
					[signMethod]: inputValues.mobileOrEmail,
					extra,
					code: verifyCode,
					password: btoa(password)

				}
				if (inputValues.affiliateCode) {
					payload = {
						...payload,
						affiliateCode: inputValues.affiliateCode,
					}
				}
				verifyRefetch(payload)
			}
		}


		if ((activeLinkIndex === 4) && validationStatus === 'valid') {
			let payload = {
				[signMethod]: inputValues.mobileOrEmail,
				extra,
				code: verifyCode,
				password: btoa(password)
			}
			verifyForgetPasswordOtp(payload)
		}
	}

	const onCheckBoxClicked = () => {
		setInputValues({ type: 'condition' })
	}

	const goToRules = () => {
		window.location.href = HOME + '/terms'
	}

	const onVerifyCodeChange = (val) => {
		if (val.length > 6) return
		if (val.length === 6) setValidationStatus('valid')
		if (validationStatus === 'valid' && val.length !== 6) setValidationStatus('normal')
		setVerifyCode(val)
	}

	const onPasswordChange = (val) => {
		const onlyEnglishRegex = /^[\x00-\x7F]*$/
		if (!onlyEnglishRegex.test(val)) return
		if (val.length >= 8) setValidationStatus('valid')
		if (validationStatus === 'valid' && val.length < 8) setValidationStatus('normal')
		setPassword(val)
	}

	useEffect(() => {
		const onEnterClick = (event) => {
			if (event.key === 'Enter') onSubmitClicked()
		}

		document.addEventListener('keydown', onEnterClick)

		return () => document.removeEventListener('keydown', onEnterClick)
	}, [validationStatus, inputValues.rulesAccepted])


	useEffect(() => {
		if (activeLinkIndex === 4) {

			forgetpassOtpRefetch()
		}
	}, [activeLinkIndex])

	return (
		<ThemeProvider theme={getMainTheme(theme, lang)}>
			<div
				className={`w-screen h-screen flex gap-x-10 justify-between text-sm lg:text-base  bg-primaryBg dark:bg-darkPrimaryBg
					}`}
				dir={lang === 'fa' ? 'rtl' : 'ltr'}
			>
				<div className='w-full max-w-md 2xl:max-w-xl 2xl:w-1/2 self-center p-4 md:p-10 mx-auto flex flex-col gap-4'>
					<Title className='mx-2'>
						<Text tid={''} className='pbold text-2xl' />
					</Title>
					<ActiveSubpage authCode={authCode} goToRules={goToRules} inputValues={inputValues} onCheckBoxClicked={onCheckBoxClicked}
						onInputValueChange={onInputValueChange} onOtpResend={onOtpResend} onVerifyCodeChange={onVerifyCodeChange}
						otpInputRef={otpInputRef} setAuthCode={setAuthCode} timer={timer} validationStatus={validationStatus} verifyCode={verifyCode}
						verifyData={verifyData}
						password={password} setPassword={setPassword}
						setValidationStatus={setValidationStatus}
						onPasswordChange={onPasswordChange}
						otpData={otpData}
						mobileOrEmail={inputValues.mobileOrEmail}
						signMethod={signMethod}
					/>
					<SubmitBtn
						id={activePath}
						active={
							validationStatus === 'valid' && (inputValues.rulesAccepted || (activeLinkIndex === 3 || activeLinkIndex === 2 || activeLinkIndex === 4))
						}
						onClick={onSubmitClicked}
					>
						{LOADING ? (
							<LoaderContainer className='mt-0'>
								<PulseLoader size={6} color='#83a8de' />
							</LoaderContainer>
						) : (
							<Text tid={'submit'} className='text-textDark' />
						)}
					</SubmitBtn>
				</div>
				<div className='hidden lg:block lg:w-1/2 h-full'>

					{width > TABLET_SIZE ?
						<Banners
							type={activePath === 'register' ? 'register' : 'login'}
						/>
						: null}
				</div>
			</div>
			<ModalLayout open={maintenanceModal} title={"Maintenance!"} width={"550px"} onClose={() => { }}>
				<div className='w-full flex flex-col gap-1 p-3' style={{ direction: "rtl" }}>
					<Text tid="کاربر گرامی،" className='text-active font-semibold' />
					<Text tid="پنل تا اطلاع ثانوی به دلیل بروزرسانی در دسترس نمی‌باشد." className='text-active font-semibold' />
				</div>
			</ModalLayout>
			<Toast />
		</ThemeProvider>
	)
}
